export default __webpack_public_path__ + "static/media/keya.adcee4b0.png";